import { Modal, ModalBody } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { verifyModal } from "../../../../slices/common/reducer";

const UpdateConfirmationModal = ({ confirmUpdate }) => {
  const dispatch = useDispatch();
  const verifyShow = useSelector((state) => state.common.verifyShow);

  const handleClose = () => {
    dispatch(verifyModal(false));
  };

  return (
    <Modal
      isOpen={verifyShow}
      onHide={() => handleClose()}
      backdrop="static"
      keyboard={false}
      className="border-0"
      modalClassName="modal fade zoomIn"
      toggle={handleClose}
    >
      <ModalBody className="modal-body">
        <h5>Are you sure you want to update?</h5>
        <div className="button-wrapper">
          <button
            type="submit"
            className="btn btn-primary save"
            id="addNewMember"
            onClick={confirmUpdate}
          >
            Yes
          </button>
          <button
            type="submit"
            className="btn btn-outline-primary cancel"
            onClick={() => handleClose(false)}
          >
            No
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default UpdateConfirmationModal;